import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { ParcelSearchContext } from 'src/components/Views/ParcelSearchV1/HomeView/ParcelSearchContext';
import Header from 'src/components/common/Header/Header';
import './MainLayoutInner.scss';

export default function MainLayoutInner() {
    const { layoutBodyRef } = useContext(ParcelSearchContext);

    return (
        <div className="main-layout">
            <header className="main-layout__header">
                <div className="main-layout__content-container">
                    <Header />
                </div>
            </header>
            <main className="main-layout__body" ref={layoutBodyRef}>
                <section className="main-layout__content-container">
                    <Outlet />
                </section>
            </main>
        </div>
    );
}
